module.exports = __webpack_public_path__ + "img/advantage-qa.342bf908.png";